module.exports = (__webpack_require__(6))(2);